const sampleStatusLabels = Object.freeze({
  ALLOCATED: 'Shipped to Patient',
  RECEIVED_BY_MICROBA: 'Received by Microba',
  ACCESSIONING: 'Processing Sample',
  RESULTS_AVAILABLE: 'Results Available',
  MICROBIOME_COACH_SESSION_COMPLETED: 'Microbiome Coach Session Completed',
  UNLABELLED: 'Unlabelled',
  UNALLOCATED: 'Unallocated',
  INVALIDATED: 'Invalidated',
  DISPATCHED_BY_CUSTOMER: 'Dispatched by Customer',
  LOST_IN_TRANSIT: 'Lost in Transit',
  DNA_EXTRACTION: 'DNA Extraction',
  DNA_LIBRARY_PREP: 'DNA Library Prep',
  SEQUENCING: 'Sequencing',
  PROCESSING: 'Processing',
  COMPLETED: 'Completed',
  FAILED_OVERLOADED: 'Failed Overloaded',
  FAILED_UNDERLOADED: 'Failed Underloaded',
  FAILED_SWAB_OTHER: 'Failed Swab Other',
  FAILED_TUBE_NOT_INTACT: 'Failed Tube Not Intact',
  FAILED_PROCESSING: 'Failed Processing'
})

export {
  sampleStatusLabels
}
